import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=608da3d8&"
import script from "./TagPage.vue?vue&type=script&lang=js&"
export * from "./TagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports